<template>
  <div>
    <v-form v-model="valid" ref="form" lazy-validation @input="onFormInput">
    <v-dialog v-model="dialog" max-width="1024px">
      <v-card>
        <v-card-title class="blue white--text">
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field required
                  label="Name"
                  v-model="editedItem.name"
                  :rules="[v => !!v || 'Name is required']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Tax ID"
                  v-model="editedItem.taxId"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-card class="elevation-0">
                  <v-card-title primary-title>
                    <div class="title">Address</div>
                  </v-card-title>
                  <v-card-text>
                    <address-form :address="editedItem.address" :disabled="false" ref="addressForm"></address-form>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md6>
                <v-card class="elevation-0">
                  <v-card-title primary-title>
                    <div class="title">Contact</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md12>
                        <v-text-field
                          name="contactPerson.name"
                          label="Name"
                          v-model="editedItem.contactPerson.name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="position"
                          label="Position"
                          v-model="editedItem.contactPerson.position"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="department"
                          label="Department"
                          v-model="editedItem.contactPerson.department"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="mobile"
                          label="Moile"
                          mask="phone"
                          v-model="editedItem.contactPerson.mobile"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="email"
                          label="Email"
                          :rules="[v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid']"
                          v-model="editedItem.contactPerson.email"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md12>
                        <v-textarea v-model="editedItem.contactPerson.note"
                          name="note"
                          label="Note"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pl-3 pr-3">
          <v-btn color="grey darken-2 white--text" @click.native="close">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green white--text" @click.native="save(editedItem)" :disabled="!valid">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-form>
    <v-card>
      <v-toolbar card>
        <v-text-field
          append-icon="search"
          label="ค้นหา"
          single-line
          hide-details
          v-model="pagination.q"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn fab dark small color="primary" @click.native.stop="dialog = true" class="text-xs-center" slot="activator">
            <v-icon dark>playlist_add</v-icon>
          </v-btn>
          <span>Add Customer</span>
        </v-tooltip>
      </v-toolbar>
      <v-data-table :loading="loading"
          :headers="headers"
          :items="loadedItems"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          class="elevation-0"
        >
        <v-progress-linear slot="progress" color="teal" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
          <td class="text-xs-left" nowrap>{{ props.item.taxId }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-center">
            <v-btn icon class="mx-0" @click="editItem(props.item)">
              <v-icon small color="teal">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="deleteItem(props.item)">
              <v-icon small color="pink">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          From {{ pageStart }} to {{ pageStop }} of {{ pagination.totalItems }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import swal from 'sweetalert2'
import AddressForm from '@/components/address'

export default {
  name: 'Customer',
  components: { AddressForm },
  data() {
    return {
      dialog: false,
      loading: false,
      valid: false,
      headers: [
        { text: '#', value: 'idx', sortable: false, align: 'center' },
        { text: 'Tax Id.', value: 'taxId', sortable: true, align: 'left' },
        { text: 'Name', value: 'name', sortable: true, align: 'left' },
        { text: '', value: '', sortable: false, align: 'left' }
      ],
      search: '',
      defaultItem: {
        name: null,
        taxId: null,
        contactPerson: {},
        address: {
          addressNo: null,
          tambon: {},
          district: {},
          province: {},
          zipcode: null,
          phone: null,
          fax: null
        }
      },
      editedItem: {
        name: null,
        taxId: null,
        contactPerson: {},
        address: {
          addressNo: null,
          tambon: {},
          district: {},
          province: {},
          zipcode: null,
          phone: null,
          fax: null
        }
      },
      editedIndex: -1,
      pagination: {
        q: null,
        sortBy: 'name',
        page: 1,
        rowsPerPage: 10,
        descending: false,
        totalItems: 0
      },
      loadedItems: []
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },
  methods: {
    onFormInput(val){
      if(val === true) {
        this.$refs.addressForm.refresh()
      }
    },
    reset() {
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    addItem() {
      this.reset()
      this.dialog = true
    },
    editItem(item) {
      this.editedIndex = this.loadedItems.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem(item) {
      swal({
        title: 'Delete customer',
        text: 'Please, confirm your action.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Confirm'
      }).then(result => {
        if (result === true) {
          this.loading = true
          this.$store
            .dispatch('customer/delete', item)
            .then(response => {
              this.loading = false
              swal({
                title: 'Success!',
                type: 'success'
              }).then(response => {
                this.$store.dispatch('customer/loadItems')
              })
            })
            .catch(error => {
              this.loading = false
              swal('Error!', error.message, 'error')
            })
        }
      })
    },
    close() {
      this.dialog = false
      setTimeout(() => this.reload(this), 300)
    },
    save(item) {
      let dispatchName =
        item.id && item.id > 0 ? 'customer/update' : 'customer/create'
      this.loading = true
      this.$store.dispatch(dispatchName, item)
        .then(response => {
          this.loading = false
          swal({
            title: 'Success!',
            type: 'success'
          }).then(response => {
            this.close()
          })
        }).catch(error => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    reload: _.debounce((self) => {
      self.loading = true
      self.reset()
      self.$store.dispatch('customer/loadItems', self.pagination)
        .then((response) => {
          self.pagination.totalItems = response.data.totalItems
          self.loadedItems = response.data.items
          self.loading = false
        }).catch((error)=>{
          self.loading = false
          swal('Error!', error.message, 'error')
        })
    }, 1000)
  },
  watch: {
    'pagination.rowsPerPage'() {
      this.reload(this)
    },
    'pagination.q'() {
      this.reload(this)
    },
    'pagination.page'() {
      this.reload(this)
    },
    'pagination.descending'() {
      this.reload(this)
    }
  },
  mounted() {
    this.reload(this)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/customers/index.vue